import { useEffect } from "react";
import { usePlayback } from "./store";

/**
 * Drives playback with a single animation frame loop. It reads and writes the
 * store directly, so the loop itself never causes a React render; components
 * re-render only because the store changed.
 */
export function useClock(): void {
  useEffect(() => {
    let frame = 0;
    let previous = performance.now();

    const tick = (now: number) => {
      const elapsed = now - previous;
      previous = now;
      const { playing, speed, advance } = usePlayback.getState();
      if (playing) {
        // A long frame (a background tab, a stall) must not teleport the
        // playhead, so the step is capped at a quarter of a second.
        advance(Math.min(elapsed, 250) * speed);
      }
      frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, []);
}
